import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import socket from "../context/socket";

const SubNav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const roomId = new URLSearchParams(window.location.search).get("clientId");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const buttons = [
    {
      label: "DiA",
      paths: ["/", "/dream", "/financial-plan", "/financial-better"],
    },
    {
      label: "My Cash Flow",
      paths: ["/my-cash-flow", "/personal-finance", "/key-action-points"],
    },
    {
      label: "Investing Beliefs",
      paths: [
        "/investing-belief",
        "/risk-reward",
        "/long-term-investing",
        "/priorities",
        "/get-on-same-page",
      ],
    },
    {
      label: "Goals",
      paths: ["/dreams-into-action", "/plan-your-goals", "/goal-tracker"],
    },
    { label: "My Investment", paths: ["/my-investment"] },
    { label: "Actionable", paths: ["/portfolio-review"] },
  ];

  const activeButton = buttons.find((button) =>
    button.paths.includes(location.pathname)
  );
  const activeLabel = activeButton ? activeButton.label : "Menu";
  const activeIndex = activeButton ? buttons.indexOf(activeButton) + 1 : 0;

  const handleClick = (button) => {
    const route = `${button.paths[0]}?clientId=${roomId}`;
    const r2 =`${button.paths[0]}`
    socket.emit("navigate", { room: roomId, url: r2 });
    navigate(route);
    setIsDropdownOpen(false);
  };


  const handleReferFriend = () => {
    navigate(`/refer-friends?clientId=${roomId}`);
    const route = '/refer-friends';
    socket.emit("navigate", { room: roomId, url:route});
  };

  return (
    <div className="container my-4">
      <div className="row">
        {/* Desktop Navigation */}
        <div className="col-md-7 d-none d-lg-block" id="button">
          {buttons.map((button, index) => (
            <button
              key={index}
              className={`fw-light me-1 ${
                button.paths.includes(location.pathname)
                  ? "btnborder active"
                  : "btndash"
              }`}
              type="button"
              onClick={() => handleClick(button)}
            >
              {button.label}
            </button>
          ))}
        </div>

        <div className="col-md-3 d-none d-lg-block">
          <img src="assets/images/line.png" alt="" className="w-100 mt-4" />
        </div>

        <div className="col-md-2 text-end d-none d-lg-block">
          <button className="btn1" type="button" onClick={handleReferFriend}>
            Refer a friend
            <img src="/assets/images/heart-emoji.svg" alt="" className="ms-2" />
          </button>
        </div>

        {/* Mobile Navigation with Dropdown */}
        <div className="col-6 d-lg-none">
          <div className="dropdown">
            <button
              className="fw-light btnactive text-start px-3 w-100 d-flex justify-content-between align-items-center"
              type="button"
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
              aria-expanded={isDropdownOpen}
              aria-controls="dropdownMenu"
            >
              {activeLabel}
              <span className="fs-12 fw-light">
                {activeIndex}/{buttons.length}
              </span>
            </button>

            {isDropdownOpen && (
              <ul
                id="dropdownMenu"
                className="dropdown-menu show w-100 mt-1 shadow-sm"
              >
                {buttons.map((button, index) => (
                  <li key={index}>
                    <button
                      className={`dropdown-item custom-dropdown-item ${
                        button.paths.includes(location.pathname) ? "active" : ""
                      }`}
                      onClick={() => handleClick(button)}
                    >
                      {button.label}
                    </button>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>

        
        <div className="col-6 d-lg-none">
          <button
            className="btn1 fw-light w-100  d-flex align-items-center justify-content-center"
            type="button"
            onClick={handleReferFriend}
          >
            Refer a Friend
            <img
              src="/assets/images/heart-emoji.svg"
              alt="Heart Emoji"
              className="ms-2"
            />
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubNav;
